import { Agency, agencyBasic, Country, country } from '@app/models/agency';
import { LocalDateType } from '@app/models/local-date';
import { gql } from 'apollo-angular';

export interface OperationPoint {
  id?: number;
  eneeId?: number;
  name?: string;
  agencyShortName?: string;
  active?: boolean;
  country?: Country;
  validFrom?: LocalDateType;
  validTo?: LocalDateType;
  longitude?: number;
  latitude?: number;
  responsibleAgency?: Agency;
  primaryLocationCode?: string;
}

export const baseOperationPoint = gql`
  fragment baseOperationPoint on OperationPoint {
    id
    name
    responsibleAgency {
      ...agencyBasic
    }
    country {
      ...country
    }
    active
  }
  ${agencyBasic}
  ${country}
`;

export const operationPoint = gql`
  fragment operationPoint on OperationPoint {
    ...baseOperationPoint
    eneeId
    primaryLocationCode
    validFrom
    validTo
    longitude
    latitude
  }
  ${baseOperationPoint}
`;
